<div role="alert" aria-live="assertive" aria-atomic="true" class="snack-alert" [class.snack-alert--error]="type === 'error'">
  <img src="assets/style-sauvage_only_logo-removebg.png" height="40px" alt="logo">
  <strong>{{ type === 'success' ? (message | translate) : message }}</strong>
</div>
